import { ReCaptchaInstance } from "recaptcha-v3";
import { AutocompleteSuggestion } from "../../models";
import { ADDRESS_AUTOCOMPLETE } from "./addresses";
import { captchaFetch } from "./captcha-fetch";

export const searchAddress = (
  query: string,
  citySelected: string,
  token: ReCaptchaInstance
): Promise<AutocompleteSuggestion[]> =>
  captchaFetch(token, `${ADDRESS_AUTOCOMPLETE}${query}+${citySelected}`)
    .then((result) => result.json())
    .then((data) => data as AutocompleteSuggestion[])
    .catch(() => []);
